export const getOrganizationSchemaData = (url: string, logo: string) => ({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Dreamlines',
    url,
    logo,
});

export const getCruiseAwaySchemaData = (baseUrl: string, logoUrl: string, phoneNumber: string) => ({
    '@context': 'https://schema.org',
    '@graph': [
        {
            '@type': 'WebSite',
            '@id': `${baseUrl}/#website`,
            url: `${baseUrl}/`,
            name: 'CruiseAway',
            inLanguage: 'en-AU',
            publisher: { '@id': `${baseUrl}/#org` },
        },
        {
            '@type': 'WebPage',
            '@id': `${baseUrl}/#webpage`,
            url: `${baseUrl}/`,
            name: 'CruiseAway - Book Best Price Guarantee Cruises',
            isPartOf: { '@id': `${baseUrl}/#website` },
            about: { '@id': `${baseUrl}/#org` },
            description:
                'Search 9000+ cruises on over 40 different cruise lines on CruiseAway. Book our custom Fly Cruise Packages with flights, hotels and transfers included.',
        },
        {
            '@type': 'TravelAgency',
            '@id': `${baseUrl}/#org`,
            name: 'CruiseAway',
            url: `${baseUrl}/`,
            description:
                'Search 9000+ cruises on over 40 different cruise lines on CruiseAway. Book our custom Fly Cruise Packages with flights, hotels and transfers included.',
            image: logoUrl,
            logo: {
                '@type': 'ImageObject',
                url: logoUrl,
            },
            address: {
                '@type': 'PostalAddress',
                streetAddress: 'Varsity Lakes',
                addressLocality: 'Queensland',
                addressRegion: 'QLD',
                postalCode: '4227',
                addressCountry: 'AU',
            },
            contactPoint: [
                {
                    '@type': 'ContactPoint',
                    contactType: 'customer service',
                    telephone: phoneNumber,
                    areaServed: 'International',
                    availableLanguage: ['en'],
                    hoursAvailable: {
                        '@type': 'OpeningHoursSpecification',
                        dayOfWeek: [
                            'https://schema.org/Monday',
                            'https://schema.org/Tuesday',
                            'https://schema.org/Wednesday',
                            'https://schema.org/Thursday',
                            'https://schema.org/Friday',
                            'https://schema.org/Saturday',
                            'https://schema.org/Sunday',
                        ],
                        opens: '09:00',
                        closes: '17:00',
                    },
                },
                {
                    '@type': 'ContactPoint',
                    contactType: 'customer service',
                    telephone: phoneNumber,
                    areaServed: 'AU',
                    availableLanguage: ['en'],
                    hoursAvailable: {
                        '@type': 'OpeningHoursSpecification',
                        dayOfWeek: [
                            'https://schema.org/Monday',
                            'https://schema.org/Tuesday',
                            'https://schema.org/Wednesday',
                            'https://schema.org/Thursday',
                            'https://schema.org/Friday',
                        ],
                        opens: '08:00',
                        closes: '17:00',
                    },
                },
            ],
            sameAs: [
                'https://www.facebook.com/cruiseaway.com.au/',
                'https://www.instagram.com/cruiseaway/',
                'https://x.com/cruiseaway',
                'https://www.youtube.com/@cruiseaway',
                'https://au.linkedin.com/company/cruiseaway-australia',
            ],
            memberOf: [
                {
                    '@type': 'Organization',
                    name: 'Cruise Lines International Association (CLIA)',
                },
                { '@type': 'Organization', name: 'IATA' },
                { '@type': 'Organization', name: 'ATAS' },
            ],
            award: ['CLIA Online Agency of the Year 2025'],
            areaServed: 'AU',
        },
    ],
});
